import React from "react";

// Small shared layout bits for the wizard's steps — mirrors the card/section
// look CustomRoleEditor already established (bg-card border rounded-card,
// section rounded-lg bg-surface-2/50) so the wizard reads as the same
// product, not a bolted-on flow.

export function SectionHeader({ title, helperText }) {
  return (
    <div className="min-w-0">
      <div className="text-sm font-medium text-text">{title}</div>
      {helperText && <div className="mt-0.5 text-xs text-text-2">{helperText}</div>}
    </div>
  );
}

export function WizardCard({ title, subtitle, children }) {
  return (
    <div className="bg-card border border-card-bd rounded-card p-4 min-w-0 flex flex-col">
      {(title || subtitle) && (
        <div className="border-b border-border pb-3 mb-4">
          {title && <h3 className="text-sm font-semibold text-text">{title}</h3>}
          {subtitle && <p className="text-xs text-text-2 mt-0.5">{subtitle}</p>}
        </div>
      )}
      {children}
    </div>
  );
}

export function WizardSection({ title, helperText, children }) {
  return (
    <section className="rounded-lg border border-border bg-surface-2/50 p-4">
      <SectionHeader title={title} helperText={helperText} />
      {children && <div className="mt-3">{children}</div>}
    </section>
  );
}

export const selectCls =
  "form-control border border-border w-full h-11 p-2 rounded-ctrl bg-card text-text text-sm";
